import React from 'react';
import { CheckCircle } from 'lucide-react';

interface PaywallHeaderProps {
  userName?: string;
}

export function PaywallHeader({ userName }: PaywallHeaderProps) {
  return (
    <div className="text-center space-y-4">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-emerald-100 mb-2">
        <CheckCircle className="w-7 h-7 text-emerald-600" />
      </div>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
        Your Business Software Blueprint Is Ready
      </h1>
      <p className="text-gray-600 max-w-md mx-auto">
        Based on your answers, we've identified the exact tools your business needs to succeed{userName ? `, ${userName}` : ''}.
      </p>
    </div>
  );
}
